// extracted by mini-css-extract-plugin
export default {"tabs":"_1zXpSYTlL5","indicator":"cOQX1dIsRU","error":"_1fGzk_v1-d"};
    if(module.hot) {
      // 1633091697891
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  